import { render, staticRenderFns } from "./PictureBuilder.vue?vue&type=template&id=1379fb2d&scoped=true"
import script from "./PictureBuilder.vue?vue&type=script&lang=js"
export * from "./PictureBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1379fb2d",
  null
  
)

export default component.exports